module.exports = __webpack_public_path__ + "static/media/bloodBtn.f2c4fde5.png";